// Alternative simplified version - add this to StopPayoutComponent.js
import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,
  Divider,
  TextField,
  InputAdornment,
  Popover,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import userblockicon from "../../../../assests/userblockicon.svg";
import "./stopPayout.css";

const StopPayoutComponent = ({
  formData,
  handleChange,
  handleSubmit,
  loading,
  partners,
  openDialog,
  handleCloseDialog,
  navigate,
  handleScroll,
  hasMore,
  handleLoadMore,
  loadMoreLoading,
  dropdownSearch,
  handleDropdownSearchChange,
  handleClearDropdownSearch,
  allPartners
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const selectRef = useRef(null);

  const handleOpenSelect = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSelect = () => {
    setAnchorEl(null);
  };

  const handlePartnerSelect = (id) => {
    handleChange({ target: { name: "franchiseeId", value: id } });
    handleCloseSelect();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'partner-select-popover' : undefined;

  const selectedPartner = partners.find(p => p.id === formData.franchiseeId);

  return (
    <div className="stop-payout-layout">
      <Sidebar />
      <div className="stop-payout-content">
        <Box className="stop-payout-header">
          <IconButton onClick={() => navigate(-1)} className="stop-payout-back-button">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" className="stop-payout-title">
            Stop Payout
          </Typography>
        </Box>

        <div className="stop-payout-container">
          <Card className="stop-payout-card">
            <CardContent>
              <form onSubmit={handleSubmit} className="stop-payout-form">
                <div className="stop-payout-form-field">
                  <FormControl fullWidth>
                    
                    <div 
                      ref={selectRef}
                      className="stop-payout-custom-select"
                      onClick={handleOpenSelect}
                    >
                      <div className="stop-payout-select-value">
                        {selectedPartner 
                          ? `${selectedPartner.name} (ID: ${selectedPartner.id})`
                          : "Select Partner"
                        }
                      </div>
                      <ExpandMoreIcon className="stop-payout-select-arrow" />
                    </div>
                  </FormControl>
                </div>

                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleCloseSelect}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  PaperProps={{
                    style: {
                      width: selectRef.current ? selectRef.current.offsetWidth : 300,
                      maxHeight: 400,
                      borderRadius: 8,
                      marginTop: 4,
                    }
                  }}
                >
                  {/* Search Box */}
                  <div className="stop-payout-dropdown-search-container">
                    <TextField
                      fullWidth
                      placeholder="Search by name or ID / Cohort ID..."
                      value={dropdownSearch}
                      onChange={handleDropdownSearchChange}
                      variant="outlined"
                      size="small"
                      className="stop-payout-dropdown-search-input"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon className="stop-payout-search-icon" />
                          </InputAdornment>
                        ),
                        endAdornment: dropdownSearch && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={handleClearDropdownSearch}
                              className="stop-payout-clear-search-button"
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      autoFocus
                    />
                    
                    {/* Search Results Info */}
                    {dropdownSearch && (
                      <div className="stop-payout-search-results-info">
                        Showing <span className="stop-payout-search-results-count">
                          {partners.length}
                        </span> of {allPartners.length} partners
                      </div>
                    )}
                  </div>

                  <Divider />

                  {/* Partners List */}
                  <div 
                    className="stop-payout-partners-list-container"
                    onScroll={handleScroll}
                  >
                    <List disablePadding>
                      {partners.length > 0 ? (
                        partners.map((partner) => (
                          <ListItem
                            key={partner.id}
                            button
                            onClick={() => handlePartnerSelect(partner.id)}
                            className="stop-payout-partner-item"
                          >
                            <ListItemText
                              primary={
                                <span className="stop-payout-partner-name">{partner.name}</span>
                              }
                              secondary={
                                <span className="stop-payout-partner-id">Cohort ID: {partner.cohortId}</span>
                              }
                            
                                
                              
                            />
                          </ListItem>
                        ))
                      ) : dropdownSearch ? (
                        <ListItem className="stop-payout-no-results-item">
                          <ListItemText 
                            primary="No partners found"
                            secondary={`Matching "${dropdownSearch}"`}
                          />
                        </ListItem>
                      ) : loading ? (
                        <ListItem>
                          <CircularProgress size={20} style={{ marginRight: "10px" }} />
                          Loading partners...
                        </ListItem>
                      ) : null}
                    </List>
                  </div>

                  {/* Load More Button */}
                  {hasMore && partners.length > 0 && !dropdownSearch && (
                    <>
                      <Divider />
                      <ListItem 
                        button
                        onClick={handleLoadMore}
                        disabled={loadMoreLoading}
                        className="stop-payout-load-more-item"
                      >
                        <div className="stop-payout-load-more-button">
                          {loadMoreLoading ? (
                            <>
                              <CircularProgress size={20} style={{ marginRight: "10px" }} />
                              Loading more...
                            </>
                          ) : (
                            "Load More"
                          )}
                        </div>
                      </ListItem>
                    </>
                  )}

                  {!hasMore && partners.length > 0 && !dropdownSearch && (
                    <ListItem className="stop-payout-no-more-item">
                      <ListItemText primary="No more partners" />
                    </ListItem>
                  )}
                </Popover>

                <div className="stop-payout-form-actions">
                  <Button
                    type="submit"
                    variant="contained"
                    className="stop-payout-submit-button"
                    disabled={!formData.franchiseeId || loading}
                  >
                    {loading ? "Processing..." : "Submit"}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>

        {/* Dialog remains same */}
          <Dialog open={openDialog} onClose={handleCloseDialog} className="stop-payout-block-dialog">
          <DialogTitle className="stop-payout-dialog-title">
            <img src={userblockicon} alt="" style={{ height: "70px", width: "70px" }} />
            <Typography variant="h5" className="stop-payout-dialog-heading">
              Payout Blocked
            </Typography>
          </DialogTitle>
          <DialogContent className="stop-payout-dialog-content">
            <Typography variant="body1" className="stop-payout-dialog-message">
              Payout Has Been Blocked Partner <br /> No Longer Eligible To Receive
            </Typography>
          </DialogContent>
          <DialogActions className="stop-payout-dialog-actions">
            <Button onClick={handleCloseDialog} className="stop-payout-dialog-button">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default StopPayoutComponent;